import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { AlsdeBackground, IAlsdeBackground } from 'src/app/core/models/background.model';
import { HttpService } from 'src/app/core/services/http.service';
import { UserService } from 'src/app/core/services/user.service';


@Component({
  selector: 'app-view-cert-dialog',
  templateUrl: './view-cert-dialog.component.html',
  styleUrls: ['./view-cert-dialog.component.scss']
})
export class ViewCertDialogComponent implements OnInit {

  bgrData: IAlsdeBackground = new AlsdeBackground();
  demographics: any = {};

  alsdeId:string = "";
  // Name passed from the caller (e.g. the eligibility list row). Used for the header so the
  // dialog always identifies the person even when the demographic lookup returns nothing.
  name:string = "";
  // Message shown when the demographic lookup fails — most commonly because the applicant
  // has not completed their required demographics (ALSDE returns a 400 in that case).
  demographicsError:string = "";
  constructor(
    private http: HttpService,
    private userService: UserService,
    public dialogRef: MatDialogRef<ViewCertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.alsdeId = data.alsdeId;
    this.name = data.name || "";
  }

  // Fetch in ngOnInit (not the constructor) so the request isn't started/lost during the
  // dialog open/teardown reflow when this dialog opens right after another (e.g. the
  // eligibility-rules "?" dialog). The name header still renders from the passed-in name.
  ngOnInit() {
    this.getUserDemographics();
  }

  getUserDemographics() {
    return this.userService.getUserDemographics(this.alsdeId).subscribe({
      next: (x: any) => {
        this.bgrData = x.background;
        this.demographics = x.demographics;
        this.demographicsError = "";
      },
      error: (err) => {
        console.log(err);
        this.bgrData = new AlsdeBackground();
        const detail = err?.error?.message || err?.error?.detail || err?.error || err?.message || "";
        this.demographicsError = (typeof detail === 'string' && /not complete|incomplete/i.test(detail))
          ? "This applicant has not completed their required demographics, so their demographic and background details are unavailable."
          : "Demographic details are unavailable for this applicant — they may not have completed their required demographics.";
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
